import { useState } from "react";
import { FinanceSettingsLayout } from "../Components/FinanceSettingsLayout";
import { useMediaQuery } from "usehooks-ts";
import { SellarImportsPayoutsTable } from "./components/SellarImportsPayoutsTable";
import { SellarImportsPayoutsCardList } from "./components/SellarImportsPayoutsCardList";
import PayoutDetailsTable from "./components/PayoutDetailsTable";
import { PayoutDetailsCardList } from "./components/PayoutDetailsCardList";

export const FinanceSettingsSellarImports = () => {
  return (
    <FinanceSettingsLayout>
      <FinanceSettingsSellarImportsContent />
    </FinanceSettingsLayout>
  );
};

const FinanceSettingsSellarImportsContent = () => {
  const isDesktop = useMediaQuery("(min-width: 1200px)");
  const [selectedPayoutId, setSelectedPayoutId] = useState<number>();

  // show mobile/desktop view of payout item

  if (selectedPayoutId) {
    return isDesktop ? (
      <PayoutDetailsTable
        selectedPayoutId={selectedPayoutId}
        onHide={() => setSelectedPayoutId(undefined)}
      />
    ) : (
      <PayoutDetailsCardList
        selectedPayoutId={selectedPayoutId}
        onHide={() => setSelectedPayoutId(undefined)}
      />
    );
  }

  // show mobile/desktop view of all payouts

  return isDesktop ? (
    <SellarImportsPayoutsTable
      onSelectPayout={(id) => {
        setSelectedPayoutId(id);
      }}
    />
  ) : (
    <SellarImportsPayoutsCardList
      onSelectPayout={(id) => {
        setSelectedPayoutId(id);
      }}
    />
  );
};
